import _ from 'lodash';

import AgentSelect from 'components/common/agent_select';
import connect from 'components/lib/connect';

const mapStateToProps = (context, props) => {
  const userRoles = {};
  _.forEach(
    context.getProvider('users').findAll({
      select: ['id', 'roleIds'],
    }),
    user => (userRoles[user.id] = user.roleIds)
  );
  let allAgents = context.getProvider('agents').findAll({
    filter: a => {
      return !a.disabledAt && userRoles[a.id] && !_.includes(userRoles[a.id], 'liveboards');
    },
  });

  const currentAgentId = context.getProvider('currentAgent').get().id;
  const selectedAgents =
    props.selectedAgentIds && !_.isEmpty(allAgents)
      ? _.filter(allAgents, agent => props.selectedAgentIds.indexOf(agent.id) > -1)
      : [];

  return {
    allAgents,
    selectedAgents,
    currentAgentId,
    header: props.header,
  };
};

const mapExecuteToProps = (executeAction, props) => {
  return { updateSelectedAgents: props.updateSelectedAgents };
};

export default connect(mapStateToProps, mapExecuteToProps)(AgentSelect);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/routing_groups/agent_select_container.js